import React from 'react';
import { Modal } from 'reactstrap';
import './QuitProjectCreationModal.css';

export const QuitProjectCreationModal = ({
  isOpen,
  onClose,
  onSaveDraft,
  onQuitWithoutSaving,
  title = 'Quitter la création du projet ?',
  message = 'Vous avez des modifications non enregistrées. Si vous quittez maintenant, ces informations seront perdues.',
  suggestion = 'Vous pouvez enregistrer ce projet en brouillon pour le reprendre et le finaliser plus tard.',
  primaryButtonLabel = 'Enregistrer en brouillon',
  secondaryButtonLabel = 'Quitter sans enregistrer',
  onPrimaryAction = null,
  onSecondaryAction = null,
  showSuggestion = true,
  showSecondaryButton = true,
  showCloseButton = true,
  variant = 'default',
  titleIcon = '',
}) => {
  const handlePrimaryAction = onPrimaryAction || onSaveDraft || onClose;
  const handleSecondaryAction = onSecondaryAction || onQuitWithoutSaving || onClose;
  const modalClassName = `quit-project-creation-modal${variant === 'enrichment' ? ' quit-project-creation-modal--enrichment' : ''}`;

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className={modalClassName}
      backdrop={true}
      keyboard={true}
      centered
    >
      <div className="quit-project-creation-modal-content">
        <div className="quit-project-creation-modal-header">
          <div className="quit-project-creation-modal-title-wrapper">
            {titleIcon ? (
              <img
                src={titleIcon}
                alt=""
                className="quit-project-creation-modal-title-icon"
                aria-hidden="true"
              />
            ) : null}
            <h2 className="quit-project-creation-modal-title">{title}</h2>
          </div>
          {showCloseButton && (
            <button
              className="quit-project-creation-modal-close-button"
              onClick={onClose}
              aria-label="Fermer"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L4 12M4 4L12 12" stroke="#666666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          )}
        </div>
        <div className="quit-project-creation-modal-body">
          <p className="quit-project-creation-modal-message">
            {message}
          </p>
          {showSuggestion && (
            <div className="quit-project-creation-modal-suggestion-box">
              <p className="quit-project-creation-modal-suggestion-text">
                {suggestion}
              </p>
            </div>
          )}
        </div>
        <div className="quit-project-creation-modal-footer">
          {showSecondaryButton && variant === 'enrichment' && (
            <button
              className="quit-project-creation-modal-quit-button"
              onClick={handleSecondaryAction}
            >
              {secondaryButtonLabel}
            </button>
          )}
          <button
            className="quit-project-creation-modal-save-draft-button"
            onClick={handlePrimaryAction}
          >
            {primaryButtonLabel}
          </button>
          {showSecondaryButton && variant !== 'enrichment' && (
            <button
              className="quit-project-creation-modal-quit-button"
              onClick={handleSecondaryAction}
            >
              {secondaryButtonLabel}
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default QuitProjectCreationModal;

